import { useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { AccountCategory } from '@futrli-sdk/predict';

import { ASSET_CATEGORIES, COADisplayAccount, LIABILITY_CATEGORIES } from '../../../../chart-of-accounts/types';
import { ASSET_CATEGORIES_PARENT, COA_SWITCH_RULE_FORM_FIELD_IDS, LIABILITY_CATEGORIES_PARENT } from './constants';

export const useSwitchRuleForm = (account: COADisplayAccount) => {
  const [categoryToSwitchTo, setCategoryToSwitchTo] = useState('');
  const [errors, setErrors] = useState<Record<string, { id: string; message: string }>>({});

  const intl = useIntl();
  const hasBeenValidated = useRef(false);

  const categories =
    ASSET_CATEGORIES.indexOf(account.category as AccountCategory) !== -1 ? LIABILITY_CATEGORIES : ASSET_CATEGORIES;

  const accountCategoryParent =
    ASSET_CATEGORIES.indexOf(account.category as AccountCategory) !== -1
      ? ASSET_CATEGORIES_PARENT
      : LIABILITY_CATEGORIES_PARENT;

  const validate = useCallback(() => {
    const newErrors: Record<string, { id: string; message: string }> = {};

    if (!categoryToSwitchTo.trim().length) {
      newErrors.category = {
        id: COA_SWITCH_RULE_FORM_FIELD_IDS.CATEGORY,
        message: intl.formatMessage({
          id: 'reporting.validation.category_is_required',
          defaultMessage: 'Category is required'
        })
      };
    }

    setErrors(newErrors);
    hasBeenValidated.current = true;
    return Object.keys(newErrors).length === 0;
  }, [categoryToSwitchTo, intl]);

  const revalidate = useCallback(() => {
    if (hasBeenValidated.current) {
      validate();
    }
  }, [validate]);

  return {
    categoryToSwitchTo,
    setCategoryToSwitchTo,
    errors,
    validate,
    revalidate,
    categories,
    accountCategoryParent
  };
};
